import React, { useState } from 'react';
import { toast } from 'react-toastify';
import TriageConfirmDialog from './TriageConfirmDialog';
import { apiReopenTriageDecision } from '../../utils/rmsApi';
import {
  CHANGE_DECISION_BODY,
  CHANGE_DECISION_FIRST_REJECTION_BODY,
  CHANGE_DECISION_LABEL,
  CHANGE_DECISION_TITLE,
  KEEP_DECISION_LABEL,
} from '../../utils/triageDecisionChange';

/**
 * ChangeDecisionButton (TDI-695)
 * ------------------------------
 * "Change my decision": a secondary action for the clinician who recorded a
 * triage decision, offered until the letter is signed off (the caller decides
 * whether to show it, from triageDecisionChange). It opens a confirm; "Keep my
 * decision" changes nothing, and "Change my decision" reopens the decision on
 * the server and hands over to `onReopened` (the decision screens).
 *
 * Props: orgId, patientRecordId, pathway, firstRejection, onReopened, className?
 */
export default function ChangeDecisionButton({
  orgId,
  patientRecordId,
  pathway,
  firstRejection = false,
  onReopened,
  className = '',
}) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await apiReopenTriageDecision({ orgId, patientRecordId, pathway });
      setOpen(false);
      onReopened?.();
    } catch (err) {
      toast.error(err?.message || 'Your decision could not be reopened. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-2 px-5 py-2 bg-white border border-primary text-primary text-sm font-medium rounded-lg hover:bg-primary/5 transition-colors ${className}`}
      >
        {CHANGE_DECISION_LABEL}
      </button>
      <TriageConfirmDialog
        open={open}
        onOpenChange={(next) => { if (!busy) setOpen(next); }}
        title={CHANGE_DECISION_TITLE}
        lines={[firstRejection ? CHANGE_DECISION_FIRST_REJECTION_BODY : CHANGE_DECISION_BODY]}
        cancelLabel={KEEP_DECISION_LABEL}
        confirmLabel={CHANGE_DECISION_LABEL}
        busy={busy}
        onConfirm={handleConfirm}
      />
    </>
  );
}
